var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-block relative",
    staticStyle: {
      "height": "36px"
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.throwErrorStatus
    }
  }), _c('v-btn', {
    staticClass: "absolute-fill",
    staticStyle: {
      "z-index": "1",
      "background": "rgb(254,195,73)"
    },
    attrs: {
      "loading": ""
    }
  }), _vm.attachPayPalButtonsStatus.pending || _vm.orderPending ? _c('v-btn', {
    staticClass: "absolute-fill",
    staticStyle: {
      "z-index": "1001",
      "background": "none",
      "pointer-events": "none"
    },
    attrs: {
      "elevation": "0"
    }
  }) : _vm._e(), _c('div', {
    ref: "btn",
    attrs: {
      "id": _vm.btnId
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }